/* eslint-disable */
import React, { useContext, useState, useEffect, useRef } from "react";
import GetCurrentTableSRNo from "../GetCurrentTableSRNo";
import {
  Button,
  Badge,
  Image,
  Collapse,
  Table,
  Modal,
  FormControl,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import {
  AFTER_SALES_ORDERS_URL,
  FILE_AUTH_URL,
  MARKET_PLACE_INVOICE_API_URL,
  GENERATE_INVOICE_API_URL,
  QUOTATIONS_REPORT_DETAILS_URL,
  PAYMENT_APPROVAL_QUOTATIONS_REPORT_DETAILS_URL,
} from "../../Shared/constant";
import CommonDateTime from "../CommonDateTime";
import ErpSyncStatus from "../ErpSyncStatus";
import { TimeSense, TimeSenseSigned } from "../TimeSense";
import { toast } from "react-toastify";
import ErpAfsRetryAPI from "../../../Api/ErpAfsRetryAPI";
import ErpRetryAPI from "../../../Api/ErpRetryAPI";
import CommonLogout from "../CommonLogout";
import wsSend_request from "../../../Api/ws/ws_request";
import { WebSocketContext } from "../../../App";
import AvatarSet from "../AvatarSet";
import MoreIcon from "../../../assets/img/more_options.png";
import QuotationsStatus from "../QuotationsStatus";
import FileDownload from "../FileDownload";
import EditIcon from "../../../assets/img/edit_icon.svg";
import MessageIcon from "../../../assets/img/message.svg";
import DownloadFile from "../../../assets/img/download_icon.svg";
import DeleteIcon from "../../../assets/img/delete_icon.svg";
import DefaultImage from "../../../assets/img/DefaultProduct.jpg";
import AmountNumberFormat from "../AmountNumberFormat";
import moment from "moment";
import BrowserUniqueTabID from "../BrowserUniqueTabID";
import CommonStatus from "../CommonStatus";
import { getColor } from "../TimeSense";
import CancelStageStatus from "../CancelStageStatus";
import GenerateInvoiceAPI from "../../../Api/GenerateInvoiceAPI";
import FBAorderLogRetryAPI from "../../../Api/FBAorderLogRetryAPI";
import DateConvertIntoReal from "../DateConvertIntoReal";
import WebOrderPaymentCancellation from "../../../Api/WebsiteOrderCancellationAPI";
import WebOrderPaymentApproval from "../../../Api/WebsiteOrderApprovalAPI";
import SendOfferNotificationAPI from "../../../Api/SendOfferNotificationAPI";
import { Form } from "react-bootstrap";
import PromoEligibleAPI from "../../../Api/PromoEligibleAPI";
import UploadFileAPI from "../../../Api/UploadFileAPI";
import UpdatePodAPI from "../../../Api/UploadPodAPI";

const TableBody = (props) => {
  const {
    isTableAllow,
    srNumber,
    OrderList,
    RowData,
    Pagination,
    EditAccess,
    OrderNewModel,
    setOrderNewModel,
    ActionColumn,
    setLoader,
    showModalNew,
    setShowModalNew,
    APIcalling,
    isCollapsable,
    ActionColumnRead,
    isTotalAndGrand,
    tabName,
    deleteCommonStateModal,
    setdeleteCommonStateModal,
    OrderViewerModal,
    setOrderViewerModal,
    AfsOrderViewerModal,
    setAfsOrderViewerModal,
    showRemarkAttachment,
    setShowRemarkAttachment,
    showModal,
    setShowModal,
    errorShowModal,
    setErrorShowModal,
    isOdiRowColorsAllow,
    ActionPreviewState,
    PreviewErrorModal,
    setPreviewErrorModal,
    selectedIds,
    setSelectedIds,
    isSelectOrder,
    isPodRowColorsAllow,
  } = props;
  const {
    accessToken,
    device_id,
    subCategorylistall,
    categorylistall,
    citylistall,
    statelistall,
    user_id,
    selfInfo,
    wareHouselistall,
    productlistall,
    ClearFormSet,
  } = useSelector((state) => state.adminReducers);
  const { websocket } = useContext(WebSocketContext);
  const [activeTableDetails, setActiveTableDetails] = useState("");
  const optionWarehouseType = [
    {
      key: "E-Bikes, Transportation Charges",
      value: "E-Bikes, Transportation Charges",
      label: "E-Bikes",
    },
    {
      key: "Spares, Service, Transportation Charges",
      value: "Spares, Service, Transportation Charges",
      label: "Spares",
    },
    {
      key: "Accessories, Transportation Charges",
      value: "Accessories, Transportation Charges",
      label: "Accessories",
    },
    {
      key: "Marketing, Transportation charges",
      value: "Marketing, Transportation charges",
      label: "Marketing",
    },
  ];
  const [CopyUrl, setCopyUrl] = useState({
    id: "",
    label: "Copy Link",
  });
  const [showPurchaseModal, setShowPurchaseModal] = useState({
    open: false,
    status: "",
    remark: "",
    id: "",
  });
  const Dispatch = useDispatch();
  const Location = useLocation();
  const PermissionsAccess = selfInfo?.user?.permissions_access;
  const [errorReason, setErrorReason] = useState("");
  var tabID = BrowserUniqueTabID();

  // VIEW MORE COLLAPOSABLE DETAILS BUTTON
  const ViewMoreDetails = (id) => {
    setActiveTableDetails(id);
  };

  // VIEW LESS COLLAPOSABLE DETAILS BUTTON
  const ElseMoreDetails = () => {
    setActiveTableDetails("");
  };

  // ORDER LOGS
  const showOrder = (value, url) => {
    let current_url =
      url === "AFS_ORDERS"
        ? "AFS Order Log"
        : url === "AFS_QUOTATIONS"
          ? "AFS Quotation Log"
          : "Order Log";

    setOrderNewModel({
      ...OrderNewModel,
      open: !OrderNewModel?.open,
      title: current_url,
      subtitle: "",
      Data: value,
    });
  };

  // OPEN ORDER DETAILS MODAL
  const OrderDetailsModal = (order_code) => {
    let param = {
      transmit: "broadcast",
      url: "order_detail",
      request: {
        order_id: order_code,
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
    setOrderViewerModal({ ...OrderViewerModal, open: !OrderViewerModal?.open });
  };

  // OPEN AFS ORDER DETAILS MODAL
  const AfsOrderDetailsModal = (order_id) => {
    let param = {
      transmit: "broadcast",
      url: "afs_order_detail",
      request: {
        order_id: order_id,
        is_weight: true,
      },
      DeviceId: device_id,
    };
    wsSend_request(websocket, param);
    setAfsOrderViewerModal({
      ...AfsOrderViewerModal,
      open: !AfsOrderViewerModal?.open,
    });
  };

  // INVOICE DETAILS
  const callInvoiceModal = (e, code, url) => {
    e.preventDefault();
    let param = {
      transmit: "broadcast",
      url: "afs_order_detail",
      request: {
        order_id: code,
      },
      DeviceId: device_id,
      modal: true,
    };
    if (url === "regular_order") {
      param.url = "order_detail";
    } else {
      param.request.is_weight = true;
    }
    wsSend_request(websocket, param);
  };

  // REGULAR INVOICE DETAILS
  const callRegularInvoiceModal = (e, code) => {
    e.preventDefault();
    let param = {
      transmit: "broadcast",
      url: "order_detail",
      request: {
        order_id: code,
      },
      DeviceId: device_id,
      TabId: tabID,
      modal: true,
    };
    wsSend_request(websocket, param);
  };

  // GET FRANCHISE NAME
  const GetFranchiseName = (billing_id) => {
    const current = OrderList?.franchise?.filter(
      (elm) => elm?.id === billing_id,
    )[0];
    return {
      name: current?.customer_name === undefined ? "-" : current?.customer_name,
    };
  };

  // GET CATEGORY NAME FROM PRODUCT LIST
  const GetCategoryFrromProductsName = (product_id) => {
    const CurrentProduct = OrderList?.product?.filter(
      (elm) => elm?.id === product_id,
    )[0];
    const CurrentSubCategory = subCategorylistall?.filter(
      (elm) => elm?.id === CurrentProduct?.sub_category_id,
    )[0];
    const CurrentCategory = categorylistall?.filter(
      (elm) => elm?.id === CurrentSubCategory?.category_id,
    )[0]?.category_name;
    return CurrentCategory;
  };

  // RETRY ERP ORDER
  const RtryFunction = async (data, url) => {
    if (url === "invoice" || url === "delivery") {
      setShowModalNew({
        ...showModalNew,
        open: !showModalNew?.open,
        title: url === "invoice" ? "Get ERP Invoice" : "Get ERP Delivery Note",
        subtitle:
          url === "invoice" ? "Get ERP Invoice" : "Get ERP Delivery Note",
        modalType: "form",
        button: "Create",
        Data: data,
      });
    } else {
      CommonAPICall(data);
    }
  };

  // SHOW FRAMES DETAILS
  // const showTable = (stock_log_id, data_) => {
  //     setShowModalNew({
  //         ...showModalNew,
  //         open: !showModalNew?.open,
  //         title: "Stock Inward Log Details",
  //         subtitle: "Stock Inward Log Details",
  //         modalType: "form",
  //         stock_log_id: stock_log_id,
  //         Txn_ID: data_?.inward_id === null ? "-": data_?.inward_id,
  //         Data: data_,
  //     });
  // };

  // SHOW ANSWER OF FAQ
  const ViewAnswer = (data) => {
    setShowModalNew({
      ...showModalNew,
      open: !showModalNew?.open,
      title: "FAQ Answer",
      modalType: "not form FAQ",
      description: `<div class="faq_wrapper">
                <label>${data?.question}</label>
                <p>${data?.answer}</p>
            </div>`,
      button: "",
    });
  };

  // FRANCHISE LATEST THREE ORDERS
  const FranchiseLastThreeOrders = (data) => {
    setShowModalNew({
      ...showModalNew,
      title: "Franchise Bikes Orders ( Latest 3 )",
      subtitle: "Franchise Orders Tables",
      modalType: "form",
      open: !showModalNew?.open,
      button: "",
      Data: data?.id,
    });
  };

  // EDIT BOX MODAL OPEN
  const EditModal = (data) => {
    setShowModalNew({
      ...showModalNew,
      open: !showModalNew?.open,
      title: "Update New Box",
      subtitle: "Update New Box",
      modalType: "form",
      button: "Update",
      Data: data,
    });
  };

  // ACCEPT REJECT ORDER MODAL
  const ModalAcceptOpen = (data, url) => {
    setShowModal({
      ...showModal,
      open: !showModal?.open,
      title: `Order ${url}`,
      Data: data,
    });
  };

  const ModalPurchaseAcceptOpen = (status, remark, id) => {
    setShowPurchaseModal({
      ...showPurchaseModal,
      open: !showPurchaseModal?.open,
      status: status,
      remark: remark,
      id: id,
    });
  };

  // SHOW SUMMARY DETAILS
  const showSummaryDetails = (data, url) => {
    if (url === "list_summary") {
      setShowModalNew({
        ...showModalNew,
        open: !showModalNew?.open,
        title: "Summary Details",
        subtitle: "Table",
        modalType: "form",
        Data: data,
      });
    } else if (url === "erp_list_summary") {
      setShowModalNew({
        ...showModalNew,
        open: !showModalNew?.open,
        title: "Summary Details",
        subtitle: "Table-ERP-General",
        modalType: "form",
        last_update_on_date: OrderList?.list[0]?.updated_at,
        Data: data,
      });
    } else if (url === "delete_age_value") {
      setdeleteCommonStateModal({
        ...deleteCommonStateModal,
        title: "Delete Age Value",
        description: `Are you sure want to delete this Age Value ?`,
        open: true,
        delete_id: data?.id,
        delete_url: "Age-Value",
      });
    } else if (url === "delete_point") {
      setdeleteCommonStateModal({
        ...deleteCommonStateModal,
        title: "Delete Point",
        description: `Are you sure want to delete this <b>${data?.start_point}-${data?.end_point}</b> range ?`,
        open: !deleteCommonStateModal?.open,
        delete_id: data?.id,
        delete_url: "Delete-Point",
      });
    } else if (url === "delete_scheme") {
      setdeleteCommonStateModal({
        ...deleteCommonStateModal,
        title: "Delete Scheme",
        description: `Are you sure want to delete this scheme ?`,
        open: true,
        delete_id: data?.id,
        delete_url: "scheme-delete",
      });
    } else if (url === "delete_notifications") {
      setdeleteCommonStateModal({
        ...deleteCommonStateModal,
        title: "Delete Notification",
        description: `Are you sure want to delete this notification ?`,
        open: true,
        delete_id: data?.id,
        date: data,
        delete_url: "notifications-delete",
      });
    }
  };

  // REMARK AND ATTCHMENT MODAL OPEN FUNCTION
  const OpenRemarkAttchModal = (order) => {
    setShowRemarkAttachment({
      ...showRemarkAttachment,
      open: !showRemarkAttachment?.open,
      title: "Add Remark & Attachemnt",
      Data: order,
    });
  };

  // ERROR SHOW MODAL
  const HandleErrorShow = (data) => {
    setErrorShowModal({
      ...errorShowModal,
      open: !errorShowModal?.open,
      title: "Error Details",
      Data: data,
    });
  };

  // PAYMENT APPROVAL
  const PaymentApproval = (data, url) => {
    setShowModalNew({
      ...showModalNew,
      open: !showModalNew?.open,
      title:
        ActionColumn?.label === "quotations_payment"
          ? "Enter Payment Details"
          : "Update Payment Details",
      subtitle:
        ActionColumn?.label === "quotations_payment"
          ? "Enter Payment Details"
          : "Update Payment Details",
      modalType: "form",
      button: "OK",
      Data: data,
    });
  };

  const OrdersPaymentApproval = async (data) => {
    try {
      let payload = {
        payment_id: data.payment_id,
        payment_method: data.payment_method,
        paymnet_order_id: data.paymnet_order_id,
        order_id: data.order_id,
      };

      if (data.emi_tenure) payload.emi_tenure = data.emi_tenure;
      if (data.emi_amount) payload.emi_amount = data.emi_amount;
      if (data.down_payment) payload.down_payment = data.down_payment;
      const response = await WebOrderPaymentApproval(payload, accessToken);

      if (response.status !== 200) {
        toast.error(response.message);
      } else {
        toast.info(response.message);
        if (APIcalling) APIcalling();
      }
    } catch (error) {
      toast.error("Error approving order:", error.message);
    }
  };

  const OrdersPaymentCancellation = async (data) => {
    try {
      const response = await WebOrderPaymentCancellation(
        {
          order_id: data.order_id,
          order_status: "CANCELLED",
          cancel_reason: "test",
        },
        accessToken,
      );
      if (response.status !== 200) {
        toast.error(response.message);
      } else {
        toast.info(response.message);
        if (APIcalling) APIcalling();
      }
    } catch (error) {
      toast.error("Error cancelling order:", error.message);
    }
  };

  // CREATE SALES ORDER FUNCTIONS
  const CreateSalesOrderFunction = (data) => {
    setShowModalNew({
      ...showModalNew,
      open: !showModalNew?.open,
      title: "Confirmation",
      subtitle: "SALE-CREATE-ORDER",
      description: "Are you sure to create sale Order?",
      modalType: "not form",
      button: "Yes",
      Data: data,
    });
  };

  // API CALLING FUCNTION
  const CommonAPICall = async (data) => {
    setLoader(true);
    const formData = new FormData();
    formData.append("order_id", data?.id);
    const response = await ErpAfsRetryAPI(formData, accessToken);
    if (response?.status === 200) {
      setLoader(false);
      APIcalling();
      toast.info(response?.message);
    } else {
      setLoader(false);
      APIcalling();
      if (response?.error) {
        toast.error(response?.error);
      } else {
        toast.error(response?.message);
      }
      if (
        response?.message === "User is not authorized." &&
        response?.status === 400
      ) {
        CommonLogout(accessToken, Dispatch);
        localStorage?.removeItem("access_token");
      }
    }
  };

  // Retry ERP order
  const RetryErpApiErrorFunction = async (data) => {
    const GetCurrentERPList = OrderList?.erp_order_log_list?.filter(
      (elm) => elm?.order_id === data?.id,
    )[0];
    setLoader(true);
    const formData = new FormData();
    formData.append("order_id", data?.id);
    const Response = GetCurrentERPList?.is_spares
      ? await ErpAfsRetryAPI(formData, accessToken)
      : await ErpRetryAPI(formData, accessToken);
    if (Response?.status === 200) {
      setLoader(false);
      APIcalling();
      toast.info(Response?.message);
    } else {
      setLoader(false);
      APIcalling();
      if (Response?.error) {
        toast.error(Response?.error);
      } else {
        toast.error(Response?.message);
      }
      if (
        Response?.message === "User is not authorized." &&
        Response?.status === 400
      ) {
        CommonLogout(accessToken, Dispatch);
        localStorage?.removeItem("access_token");
      }
    }
  };

  // Retry ERP order
  const RetryFbaApiErrorFunction = async (data) => {
    setLoader(true);
    const formData = new FormData();
    formData.append("order_id", data?.id);
    const response = await FBAorderLogRetryAPI(formData, accessToken);
    if (response?.status === 200) {
      setLoader(false);
      APIcalling();
      toast.info(response?.message);
    } else {
      setLoader(false);
      APIcalling();
      if (response?.error) {
        toast.error(response?.error);
      } else {
        toast.error(response?.message);
      }
      if (
        response?.message === "User is not authorized." &&
        response?.status === 400
      ) {
        CommonLogout(accessToken, Dispatch);
        localStorage?.removeItem("access_token");
      }
    }
  };

  // order success reject flow
  const OrderSuccesReject = (url) => {
    if (showModal?.Reason?.trim() !== "") {
      setErrorReason("");
      const param = {
        transmit: "broadcast",
        url: "order_cancelled",
        request: {
          order_id: showModal?.Data?.id,
          cancel_reason: showModal?.Reason?.trim(),
          order_status:
            url === "Order Accept"
              ? "CANCELLED"
              : showModal?.Data?.cancel_stage,
        },
        DeviceId: device_id,
      };
      wsSend_request(websocket, param);
    } else {
      setErrorReason("Please enter reason");
    }
  };

  const PromoEligibilityAccepted = async () => {
    try {
      if (showPurchaseModal?.remark) {
        setErrorReason("");
        let payload = {
          purchase_id: showPurchaseModal.id,
          remark: showPurchaseModal.remark,
          promo_eligible: showPurchaseModal.status,
        };
        const response = await PromoEligibleAPI(accessToken, payload);
        if (response.status !== 200) {
          if (response.message) {
            toast.error(response.message);
          }
          if (response.error) {
            toast.error(response.error);
          }
        } else {
          toast.info(response.message);
          setShowPurchaseModal({ status: "", remark: "", id: "" });
          if (APIcalling) APIcalling();
        }
      } else {
        setErrorReason("Please enter reason");
        return;
      }
    } catch (error) {
      toast.error(
        "Error while marking promocode eligibility status",
        error.message,
      );
    }
  };

  // const maskEmail = (email) => {
  //     if (!email.includes('@')) return '*'.repeat(email.length);
  //     const [name, domain] = email.split('@');
  //     return '*'.repeat(name.length) + '@' + domain;
  // };

  const maskString = (input, type) => {
    if (!input || typeof input !== "string") return "";

    if (
      selfInfo?.user?.user_type === "super_admin" ||
      PermissionsAccess?.CRMTools[1]?.Edit ||
      PermissionsAccess?.CRMTools[2]?.Edit
    ) {
      return input;
    } else {
      switch (type) {
        case "email":
          return "*".repeat(input.length);
        case "mobile":
          return input.replace(/\d/g, "*");
        default:
          return "*".repeat(input.length);
      }
    }
  };

  // Generate Invoice
  const GenerateInvoicFunction = async (elm) => {
    setLoader(true);
    const GenerateInvoiceAPIData_ = await GenerateInvoiceAPI(
      `${GENERATE_INVOICE_API_URL}/${elm?.invoice_no}`,
      accessToken,
    );
    if (GenerateInvoiceAPIData_?.status === 200) {
      setLoader(false);
      APIcalling();
    } else {
      APIcalling();
      const response = GenerateInvoiceAPIData_?.msg;
      setLoader(false);
      if (response !== "Invoice not found") {
        setErrorShowModal({
          ...errorShowModal,
          open: !errorShowModal?.open,
          title: "Error Details",
          Data: response,
        });
      } else {
        toast.error(response);
      }
    }
  };

  // close modal
  const onClose = () => {
    setShowModal({
      ...showModal,
      open: false,
    });
    setShowPurchaseModal({
      ...showPurchaseModal,
      open: false,
      status: "",
      id: "",
      remark: "",
    });
    setErrorReason("");
  };

  useEffect(() => {
    if (
      ClearFormSet?.action === 200 &&
      ClearFormSet?.url == "order_cancelled"
    ) {
      setShowModal({
        ...showModal,
        open: false,
        title: "",
        modalType: "",
        Reason: "",
        Data: {},
      });
    }
  }, [ClearFormSet]);

  const podInputRef = useRef(null);

  const uploadPodFile = async (file) => {
    if (!file) return null;

    const formData = new FormData();
    formData.append("file", file, file.name);

    const fileresponse = await UploadFileAPI(accessToken, formData);
    toast.info(fileresponse.message);

    if (fileresponse?.status === 200) {
      return fileresponse?.id;
    }

    return null;
  };

  const handlePodUpload = async (e, orderId) => {
    const file = e.target.files[0];
    if (!file) return;

    // 1️⃣ Upload file first
    toast.info("Uploading POD File! Wait...");
    const podFileId = await uploadPodFile(file);

    if (podFileId) {
      const payload = {
        order_id: orderId,
        pod_link: podFileId,
      };

      const response = await UpdatePodAPI(payload, accessToken);

      if (response.status >= 400) {
        toast.error(response.message);
        if (APIcalling) APIcalling();
        return;
      }
      toast.success(response.message);
      if (APIcalling) APIcalling();
    }
  };

  // COMMON BUTTON FUNCTION
  const CommonButton = ({ data }) => {
    return (
      <td>
        {ActionColumn?.label === "retry" ? (
          <Button
            className="btn edittable edittableretry btn btn-primary"
            // onClick={() => RtryFunction(data, (data?.erp_id === null || data?.erp_id === "") ? "retry" : "invoice")}
            onClick={() =>
              RtryFunction(
                data,
                data?.erp_id === null || data?.erp_id === ""
                  ? "retry"
                  : data?.erp_order_type === "Warranty"
                    ? "delivery"
                    : "invoice",
              )
            }
          >
            {/* {(data?.erp_id === null || data?.erp_id === "") ? (<>
                    <i className="bi bi-arrow-repeat"></i> Retry
                </>) : (<>
                    <i className="bi bi-receipt"></i> Get Invoice
                </>)} */}
            {data?.erp_id === null || data?.erp_id === "" ? (
              <>
                <i className="bi bi-arrow-repeat"></i> Retry
              </>
            ) : data?.erp_order_type !== "Warranty" ? (
              <>
                <i className="bi bi-receipt"></i> Get Invoice
              </>
            ) : (
              <>
                <i className="bi bi-truck"></i> Get Delivery Note
              </>
            )}
          </Button>
        ) : ActionColumn?.label === "edit_box_modal" ? (
          <Button
            className="btn edittable edittableretry btn btn-primary"
            onClick={() => EditModal(data, "edit_box")}
          >
            <Image src={EditIcon} alt="edit" />
          </Button>
        ) 
        // : ActionColumn?.label === "pod_upload" ? (
        //   showPodUploadButton(data?.pod_signature_confidence) && (
        //     <>
        //       <input
        //         type="file"
        //         style={{ display: "none" }}
        //         ref={podInputRef}
        //         onChange={(e) => handlePodUpload(e, data.id)}
        //       />{" "}
        //       <Button
        //         className="badge bg-success btn"
        //         onClick={() => podInputRef.current.click()}
        //       >
        //         Re-Upload POD
        //       </Button>
        //     </>
        //   )
        // )
         : ActionColumn?.label === "edit_file_purchase_download" ? (
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "6px" }}
          >
            <Link
              className="btn edittable"
              to={`${ActionColumn?.naviagte}${data?.id}`}
            >
              <Image src={EditIcon} alt="edit" />
            </Link>
            {data?.view_file_url !== null && (
              <a
                className="btn edittable edittableretry btn btn-primary"
                href={
                  data?.device !== "web"
                    ? `${process.env.REACT_APP_BASE_URL}file/${data?.view_file_url || ""}`
                    : data?.view_file_url?.replace("view/file/", "")
                }
                target="_blank"
              >
                <Image src={DownloadFile} alt="edit" />
              </a>
            )}
            {!data.remark && data.promo_code && (
              <Button
                className="formbtnsuccess widthfullbtn fw-bold"
                style={{ float: "right", width: "auto", fontSize: "0.95em" }}
                onClick={() => ModalPurchaseAcceptOpen("ACCEPTED", "", data.id)}
                variant="primary"
              >
                Accept
              </Button>
            )}
            {!data.remark && data.promo_code && (
              <Button
                className="formbtndanger widthfullbtn fw-bold"
                style={{ float: "right", width: "auto", fontSize: "0.95em" }}
                onClick={() => ModalPurchaseAcceptOpen("REJECTED", "", data.id)}
                variant="primary"
              >
                Reject
              </Button>
            )}
          </div>
        ) : ActionColumn?.label ===
          "sale_purchase_edit_file_purchase_download" ? (
          <div>
            {data?.view_file_url !== null && (
              <a
                className="btn edittable edittableretry btn btn-primary"
                id="invoice_download_purchase"
                href={
                  process.env.REACT_APP_BASE_URL + "file/" + data?.view_file_url
                }
                target="__blank"
              >
                <Image src={DownloadFile} alt="edit" />
              </a>
            )}
          </div>
        ) : ActionColumn?.label === "edit_delete" ||
          ActionColumn?.label === "edit_delete_point" ||
          ActionColumn?.label === "edit_delete_scheme" ? (
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "6px" }}
          >
            <Link
              className="btn edittable"
              to={`${ActionColumn?.naviagte}${data?.id}`}
            >
              <Image src={EditIcon} alt="edit" />
            </Link>
            <Button
              className="btn edittable edittableretry btn btn-primary"
              onClick={() =>
                showSummaryDetails(
                  data,
                  ActionColumn?.label === "edit_delete_point"
                    ? "delete_point"
                    : ActionColumn?.label === "edit_delete_scheme"
                      ? "delete_scheme"
                      : "delete_age_value",
                )
              }
            >
              <Image src={DeleteIcon} alt="edit" />
            </Button>
          </div>
        ) : ActionColumn?.label === "edit_help_desk_faq" ? (
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "6px" }}
          >
            <button
              className="btn view_more_btn"
              onClick={() => ViewAnswer(data)}
              aria-controls="example-collapse-text"
            >
              <i className="bi bi bi-eye"></i> Answer
            </button>
            {(selfInfo?.user?.user_type === "super_admin" ||
              PermissionsAccess?.DealerApp[5]?.Edit) && (
              <Link
                className="btn edittable"
                to={`${ActionColumn?.naviagte}${data?.id}`}
              >
                <Image src={EditIcon} alt="edit" />
              </Link>
            )}
          </div>
        ) : ActionColumn?.label === "add_remark_modal" ? (
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "6px" }}
          >
            <button
              className="btn add_remark"
              onClick={() => OpenRemarkAttchModal(data)}
            >
              <i className="bi bi-chat-left-text"></i>
            </button>
          </div>
        ) : ActionColumn?.label === "order_accept_reject" ? (
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "6px" }}
          >
            {data?.order_type === "AO" &&
            (data?.order_status === "CANCELLED_REQUEST" ||
              data?.order_status === "RETURN_REQUEST" ||
              data?.order_status === "REPLACE_REQUEST") ? (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  columnGap: "6px",
                }}
              >
                <Button
                  variant="primary"
                  size="sm"
                  onClick={() => ModalAcceptOpen(data, "Accept")}
                >
                  Accept
                </Button>
                <Button
                  variant="danger"
                  size="sm"
                  className="btn"
                  onClick={() => ModalAcceptOpen(data, "Reject")}
                >
                  Reject
                </Button>
              </div>
            ) : (
              "-"
            )}
          </div>
        ) : ActionColumn?.label === "Erp-Api-Failure-Retry" ? (
          <Button
            className="btn edittable edittableretry btn btn-primary"
            onClick={() => RetryErpApiErrorFunction(data)}
          >
            <i className="bi bi-arrow-repeat"></i> Retry
          </Button>
        ) : ActionColumn?.label === "fba-orders-Api-Failure-Retry" ? (
          <Button
            className="btn edittable edittableretry btn btn-primary"
            onClick={() => RetryFbaApiErrorFunction(data)}
          >
            <i className="bi bi-arrow-repeat"></i> Retry
          </Button>
        ) : ActionColumn?.label === "quotations_payment" ||
          ActionColumn?.label === "quotations_payment_approval" ? (
          <Button
            className="btn donwload_btn"
            onClick={() => PaymentApproval(data, ActionColumn?.label)}
          >
            {ActionColumn?.label === "quotations_payment"
              ? "Payment Details"
              : "Update Payment Details"}
          </Button>
        ) : ActionColumn?.label === "orders_payment_approval" ? (
          <div className="d-flex gap-2">
            <Badge
              bg="danger"
              onClick={() => {
                OrdersPaymentCancellation(data);
              }}
              style={{ cursor: "pointer" }}
            >
              Reject
            </Badge>
            <Badge
              bg="success"
              onClick={() => {
                OrdersPaymentApproval(data);
              }}
              style={{ cursor: "pointer" }}
            >
              Approve
            </Badge>
          </div>
        ) : ActionColumn?.label === "create_so_from_quotation" ? (
          <React.Fragment>
            {data?.erp_quotation_code !== null &&
            data?.erp_quotation_code !== "" ? (
              <>
                {!data?.is_afs_order_created && (
                  <Button
                    className="btn donwload_btn"
                    onClick={() => CreateSalesOrderFunction(data)}
                  >
                    Create Sale Order
                  </Button>
                )}
              </>
            ) : (
              "-"
            )}
          </React.Fragment>
        ) : ActionColumn?.label === "edit_notification" ? (
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "6px" }}
          >
            <Link
              className="btn edittable"
              to={`${ActionColumn?.naviagte}/${data?.id}`}
            >
              <Image src={EditIcon} alt="edit" />
            </Link>
            <Button
              className="btn edittable edittableretry btn btn-primary"
              onClick={() => showSummaryDetails(data, "delete_notifications")}
            >
              <Image src={DeleteIcon} alt="edit" />
            </Button>
          </div>
        ) : ActionColumn?.label === "edit_marketing_campaign" ? (
          <Link
            className="btn edittable"
            to={`${ActionColumn?.naviagte}/${data?.id}`}
          >
            <Image src={EditIcon} alt="edit" />
          </Link>
        ) : ActionColumn?.label === "edit_offer_scheme" ? (
          <div className="d-flex align-items-center" style={{ gap: "1em" }}>
            <Link
              className="btn edittable"
              to={`${ActionColumn?.naviagte}/${data?.id}`}
            >
              <Image src={EditIcon} alt="edit" />
            </Link>
            <button
              className="btn edittable"
              onClick={() => {
                triggerNotificationOffer(data?.id);
              }}
              type="button"
            >
              <Image src={MessageIcon} alt="message" />
            </button>
          </div>
        ) : ActionColumn?.label === "edit_user_management" ? (
          <React.Fragment>
            {data?.user_type !== "super_admin" ? (
              <Link
                className="btn edittable edittableretry btn btn-primary"
                to={`${ActionColumn?.naviagte}${data?.id}`}
              >
                <Image src={EditIcon} alt="edit" />
              </Link>
            ) : (
              "-"
            )}
          </React.Fragment>
        ) : (
          <Link
            className="btn edittable edittableretry btn btn-primary"
            to={`${ActionColumn?.naviagte}${data?.id}`}
          >
            <Image src={EditIcon} alt="edit" />
          </Link>
        )}
      </td>
    );
  };

  // COMMON BUTTON READ
  const CommonButtonRead = ({ data }) => {
    if (ActionColumnRead?.url === "stock-inward-log") {
      return (
        <td>
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "6px" }}
          >
            {/* {data?.is_bike && (<span className="btn edittable" onClick={() => showTable(data?.id, data)}>
                        <i className="bi bi-eye"></i>
                    </span>)} */}
            {data?.view_file_url !== null && (
              <a
                href={
                  process.env.REACT_APP_BASE_URL + "file/" + data?.view_file_url
                }
                className="downloadaction"
                target="__blank"
              >
                <i className="bi bi-file-earmark-arrow-down"></i>
              </a>
            )}
          </div>
        </td>
      );
    }
  };

  // error message modal open
  const ErrorMessageShow = (data, url) => {
    if (url === "erp_order_synce_error_view") {
      const GetCurrentERPList = OrderList?.erp_order_log_list?.filter(
        (elm) => elm?.order_id === data?.id,
      )[0];
      setPreviewErrorModal({
        ...PreviewErrorModal,
        open: open,
        Title: "Sales Order Error",
        Data: GetCurrentERPList,
      });
    } else if (url === "fba_order_synce_error_view") {
      const GetCurrentERPList = OrderList?.erp_invoice_log_list?.filter(
        (elm) => elm?.order_id === data?.id,
      )[0];
      setPreviewErrorModal({
        ...PreviewErrorModal,
        open: open,
        Title: "Fba Order Error",
        Data: GetCurrentERPList,
      });
    } else if (url === "show_sales_person_purchase_list") {
      setShowModalNew({
        ...showModalNew,
        title: "Sale Purchase Details",
        subtitle: "Sale Purchase Details",
        modalType: "form",
        open: !showModalNew?.open,
        button: "",
        Data: {
          sales_id: data?.sales_id,
          start_date: data?.start_date,
          end_date: data?.end_date,
        },
      });
    } else if (
      url === "erp_store_level_log_view" ||
      url === "erp_store_details_log_view"
    ) {
      setPreviewErrorModal({
        ...PreviewErrorModal,
        open: open,
        Title:
          url === "erp_store_level_log_view"
            ? "Stock Level Request Data"
            : "Stock Details Request Data",
        Data: {
          request_data: data?.request_data,
          updated_at: data?.updated_at,
        },
      });
    }
  };

  // COMMON PREIVEW BUTTON
  const CommonPreviewButton = ({ data }) => {
    if (ActionPreviewState?.url === "erp_api_failures_error_view") {
      return (
        <td>
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "6px" }}
          >
            <Button
              className="btn edittable btn btn-primary"
              onClick={() =>
                ErrorMessageShow(data, "erp_order_synce_error_view")
              }
            >
              <i className="bi bi-eye"></i>
            </Button>
          </div>
        </td>
      );
    } else if (ActionPreviewState?.url === "fba_orders_failures_error_view") {
      return (
        <td>
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "6px" }}
          >
            <Button
              className="btn edittable btn btn-primary"
              onClick={() =>
                ErrorMessageShow(data, "fba_order_synce_error_view")
              }
            >
              <i className="bi bi-eye"></i>
            </Button>
          </div>
        </td>
      );
    } else if (
      ActionPreviewState?.url === "sales_person_performance_purchase_list"
    ) {
      return (
        <td>
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "6px" }}
          >
            <OverlayTrigger
              placement="left"
              delay={{ show: 250, hide: 100 }}
              overlay={
                <Tooltip
                  style={{ position: "fixed" }}
                  id="button-tooltip"
                  {...props}
                >
                  View Purchase List
                </Tooltip>
              }
            >
              <Button
                className="btn edittable btn btn-primary"
                onClick={() =>
                  ErrorMessageShow(data, "show_sales_person_purchase_list")
                }
              >
                <i className="bi bi-eye"></i>
              </Button>
            </OverlayTrigger>
          </div>
        </td>
      );
    } else if (
      ActionPreviewState?.url === "erp_store_level_log_view" ||
      ActionPreviewState?.url === "erp_store_details_log_view"
    ) {
      return (
        <td>
          <div
            style={{ display: "flex", alignItems: "center", columnGap: "6px" }}
          >
            <Button
              className="btn edittable btn btn-primary"
              onClick={() => ErrorMessageShow(data, ActionPreviewState?.url)}
            >
              <i className="bi bi-eye"></i>
            </Button>
          </div>
        </td>
      );
    }
  };

  let CurrentColspan = RowData?.length + 1;

  if (EditAccess && ActionColumn?.isShow) {
    CurrentColspan += 1;
  }

  // GET NAME
  const GetName = (id, url) => {
    const currentName = OrderList?.[url?.list]?.filter(
      (elm) => id === elm?.id,
    )[0]?.[url?.label];
    return currentName === undefined ? "-" : currentName;
  };

  // GET STATE NAME FROM PINCODES
  const GetPincodeSearch = (id, url) => {
    const CurrentProduct = OrderList?.[url?.list]?.filter(
      (elm) => id === elm?.id,
    )[0];
    const GetCurrentStateName = statelistall?.filter(
      (elm) => CurrentProduct?.state_id === elm?.id,
    )[0];
    return {
      state_name: GetCurrentStateName?.state_name,
      gst_code: GetCurrentStateName?.gst_code,
    };
  };

  // GET FS CODE WITH PRODUCT NAME
  const GetAFSporductName = (id, url) => {
    const CurrentProduct = OrderList?.[url?.list]?.filter(
      (elm) => id === elm?.id,
    )[0];
    return (
      CurrentProduct?.product_name + ` - (${CurrentProduct?.product_code})`
    );
  };

  // GET CITY NAME
  const GetCityName = (id, url) => {
    const CurrentProduct = OrderList?.[url?.list]?.filter(
      (elm) => id === elm?.id,
    )[0];
    const CurrentCity = citylistall?.filter(
      (elm) => CurrentProduct?.district_id === elm?.id,
    )[0];
    return CurrentCity?.district_name;
  };

  // GET STATE NAME
  const GetStateName = (id, url) => {
    const CurrentProduct = OrderList?.[url?.list]?.filter(
      (elm) => id === elm?.id,
    )[0];
    const CurrentCity = citylistall?.filter(
      (elm) => CurrentProduct?.district_id === elm?.id,
    )[0];
    const CurrentState = statelistall?.filter(
      (elm) => CurrentCity?.state_id === elm?.id,
    )[0];
    return CurrentState?.state_name;
  };

  // get ship from warehouse name
  const GetCurrentWarehouse = (warehouse_id) => {
    const CurrentWAREHOUSE = wareHouselistall?.filter(
      (elm) => elm?.id === warehouse_id,
    )[0];
    return CurrentWAREHOUSE?.display_name;
  };

  // GET BRAND NAME
  const GetBrandName = (sub_category) => {
    const SubCategoryListx = OrderList?.sub_category?.filter(
      (elm) => sub_category === elm?.id,
    )[0];
    const CategoryListX = OrderList?.category?.filter(
      (elm) => SubCategoryListx?.category_id === elm?.id,
    )[0];
    const BrandName = OrderList?.brand_list?.filter(
      (elm) => CategoryListX?.brand_id === elm?.id,
    )[0]?.brand_name;
    return BrandName;
  };

  // GET CATEGORY NAME
  const GetCategoryName = (sub_category) => {
    const SubCategoryListx = OrderList?.sub_category?.filter(
      (elm) => sub_category === elm?.id,
    )[0];
    const CategoryListX = OrderList?.category?.filter(
      (elm) => SubCategoryListx?.category_id === elm?.id,
    )[0]?.category_name;
    return CategoryListX;
  };

  // GET WAREHOUSE TYPE NAME
  const GetWarehouseTypeName = (warehouse_type) => {
    const CurrentWarehosueTypes = optionWarehouseType?.filter(
      (elm) => elm?.value === warehouse_type,
    )[0];
    return CurrentWarehosueTypes?.label === undefined
      ? "-"
      : CurrentWarehosueTypes?.label;
  };

  // GEST REGION NAME
  const GetRegionName = (region_id) => {
    if (region_id !== undefined) {
      const CurrentRegion = OrderList?.region_list?.filter(
        (elm) => region_id === elm?.id,
      )[0];
      return CurrentRegion === undefined ? "-" : CurrentRegion?.region_name;
    } else {
      return "-";
    }
  };

  // TOTAL TABLE GRAND AND NORMAL TOTAL
  const TotalTableCount = (list, url) => {
    if (list?.length > 0) {
      if (url === "credit_amt") {
        let sum = 0;
        for (let i = 0; i < list.length; i++) {
          sum += parseInt(list[i]?.credit_amt);
        }
        return sum;
      } else if (url === "debit_amt") {
        let sum = 0;
        for (let i = 0; i < list.length; i++) {
          sum += parseInt(list[i]?.debit_amt);
        }
        return sum;
      } else if (url === "inward_qty") {
        let sum = 0;
        for (let i = 0; i < list.length; i++) {
          sum += parseInt(list[i]?.inward_qty);
        }
        return sum;
      } else if (url === "transfer_qty") {
        let sum = 0;
        for (let i = 0; i < list.length; i++) {
          sum += parseInt(list[i]?.transfer_qty);
        }
        return sum;
      } else if (url === "inward_qty - transfer_qty") {
        let sum = 0;
        for (let i = 0; i < list.length; i++) {
          sum += parseInt(list[i]?.inward_qty - list[i]?.transfer_qty);
        }
        return sum < 0 ? 0 : sum;
      } else if (url === "inward_qty - invoiceable_qty") {
        let sum = 0;
        for (let i = 0; i < list.length; i++) {
          sum += parseInt(list[i]?.inward_qty - list[i]?.invoiceable_qty);
        }
        return sum;
      } else if (url === "TotalProduct") {
        let sum = 0;
        for (let i = 0; i < list.length; i++) {
          sum += GetProductSTockValue(
            list[i]?.product_id,
            list[i]?.inward_qty,
            list[i]?.transfer_qty,
          );
        }
        return sum;
      }
    } else {
      return 0;
    }
  };

  // COMMON DATE FUNCTION
  const CommonDateTimeCommon = (date, url) => {
    if (url === "desktop") {
      if (date !== null) {
        const currentTimezone = moment.tz.guess();
        return moment(date)
          .tz(currentTimezone)
          .format("MMMM Do YYYY, h:mm:ss a");
      } else {
        return "-";
      }
    } else {
      if (date !== null) {
        const currentTimezone = moment.tz.guess();
        return moment(date).tz(currentTimezone).format("MM/DD/YYYY");
      } else {
        return "-";
      }
    }
  };

  // GET SALES PERSON PERFORMANCE STATUS
  function getStatus(data) {
    const currentDate = new Date();
    const startDate = new Date(data.start_date);
    const endDate = new Date(data.end_date);

    const resetTime = (date) =>
      new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const currentDateWithoutTime = resetTime(currentDate);
    const startDateWithoutTime = resetTime(startDate);
    const endDateWithoutTime = resetTime(endDate);
    const targetAchieved = parseInt(data.target_achived ?? 0);
    const target = parseInt(data.target);

    if (currentDateWithoutTime < startDateWithoutTime) {
      return (
        <Badge bg="info" className="status_mark yet_to_start">
          Yet to start
        </Badge>
      );
    } else if (
      currentDateWithoutTime >= startDateWithoutTime &&
      currentDateWithoutTime <= endDateWithoutTime
    ) {
      if (targetAchieved >= target) {
        return (
          <Badge bg="success" className="status_mark">
            Completed
          </Badge>
        );
      }
      return (
        <Badge bg="warning" className="status_mark in_progress">
          In progress
        </Badge>
      );
    } else if (currentDateWithoutTime > endDateWithoutTime) {
      if (targetAchieved >= target) {
        return (
          <Badge bg="success" className="status_mark">
            Completed
          </Badge>
        );
      }
      return (
        <Badge bg="danger" className="status_mark">
          Expired
        </Badge>
      );
    }
  }

  // Market Place Invocie
  const MarketPlaceInvocie = async (invoice_code, uni_code) => {
    window.open(
      MARKET_PLACE_INVOICE_API_URL +
        "?invoice_code=" +
        invoice_code +
        "&uni_code=" +
        uni_code,
      "_blank",
    );
  };

  const AddOrderColorRow = (elm) => {
    return elm?.is_odi
      ? "is_odi_order_active"
      : elm?.is_courier_pin_code
        ? "is_courier_pin_code_order_active"
        : "";
  };

  const AddRowClassName = (data) => {
    let page_url = Location?.pathname?.split("/")[1];

    if (page_url === "users") {
      return data?.id === user_id ? "active_user" : "";
    } else if (page_url === "create-franchise") {
      if (!data?.is_active) {
        return "Order-NoActive-Row";
      } else if (data?.order_count === 0 && data?.is_active) {
        return "Order-NotBilled-Row";
      } else {
      }
    }
  };

  // get total balance and Credit Limit
  const GetCurrentOrderRate = (current) => {
    const getCurrentFranchise = OrderList?.franchise?.filter(
      (elm) => elm?.id === current?.billing_id,
    )[0];

    return {
      erp_credit_limit: getCurrentFranchise?.erp_credit_limit,
      erp_outstanding: getCurrentFranchise?.erp_outstanding,
    };
  };

  function displayZeroIfNegative(number) {
    if (number < 0) {
      return 0;
    } else {
      return number;
    }
  }

  // get product inward_qty
  const GetProductSTockValue = (product_id, inward_qty, transfer_qty) => {
    const CurrentProduct = productlistall?.filter(
      (elm) => elm?.id === product_id,
    )[0];
    return isNaN(
      Math.round(
        parseFloat(CurrentProduct?.mrp) *
          (parseInt(inward_qty) - parseInt(transfer_qty)) *
          100,
      ) / 100,
    )
      ? 0
      : Math.round(
          parseFloat(CurrentProduct?.mrp) *
            (parseInt(inward_qty) - parseInt(transfer_qty)) *
            100,
        ) / 100;
  };

  // payment url copy
  const PaymentLinkCompy = (payment_id) => {
    var urlText = document.getElementById(payment_id).innerText; // Get the text from <p>
    navigator.clipboard
      .writeText(urlText)
      .then(() => {
        setCopyUrl({
          ...CopyUrl,
          id: payment_id,
          label: "URL Copied !",
        });

        setTimeout(() => {
          setCopyUrl({
            ...CopyUrl,
            id: "",
            label: "Copy Link",
          });
        }, 2000);
      })
      .catch((err) => {
        setCopyUrl({
          ...CopyUrl,
          id: "",
          label: "Copy Link",
        });
      });
  };

  const triggerNotificationOffer = async (id) => {
    const response = await SendOfferNotificationAPI(accessToken, id);
    if (response.status >= 400) {
      toast.error(response.message);
      return;
    }
    toast.success(response.message);
  };

  const toggleRow = (id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  useEffect(() => {
    if (isSelectOrder !== undefined && isSelectOrder !== null) {
      if (!isSelectOrder) {
        setSelectedIds(new Set());
      }
    }
  }, [isSelectOrder]);

  const handleOrderCheckboxChange = (itemId, selectedIds, toggleRow) => {
    if (selectedIds.size >= 10 && !selectedIds.has(itemId)) {
      toast.error("You can only select 10 items.");
      return;
    }
    toggleRow(itemId);
  };

  const getPodStatusClass = (status) => {
    switch (status) {
      case "Critical":
      case "CRITICAL":
        return "is_pod_critical";
      case "Slightly Critical":
      case "SLIGHTLY CRITICAL":
      case "SLIGHTLY_CRITICAL":
        return "is_pod_slightly_critical";
      case "Good":
      case "GOOD":
        return "is_pod_good";
      case "BEST":
      case "Best":
        return "is_pod_best";
      default:
        return "";
    }
  };

  const showPodUploadButton = (status) => {
    switch (status) {
      case "Critical":
      case "CRITICAL":
        return true;
      case "Slightly Critical":
      case "SLIGHTLY CRITICAL":
      case "SLIGHTLY_CRITICAL":
        return true;
      default:
        return false;
    }
  };

  // (optional) clear all
  const clearSelection = () => setSelectedIds(new Set());
  return (
    <tbody>
      {OrderList?.list?.map((item, rowIndex) => {
        return (
          <React.Fragment key={rowIndex}>
            <tr
              className={`
    ${isOdiRowColorsAllow ? AddOrderColorRow(item) : AddRowClassName(item)}
    ${isPodRowColorsAllow && getPodStatusClass(item.pod_signature_confidence)}
  `}
              key={rowIndex}
            >
              {isTableAllow && isCollapsable && (
                <td>
                  <Button
                    className={
                      activeTableDetails === item?.id
                        ? "btn actionbtn active"
                        : "btn actionbtn"
                    }
                    onClick={() =>
                      activeTableDetails === item?.id
                        ? ElseMoreDetails()
                        : ViewMoreDetails(item?.id)
                    }
                    aria-controls="example-collapse-text"
                    aria-expanded={
                      activeTableDetails === item?.id ? true : false
                    }
                  >
                    <Image src={MoreIcon} alt="more icon" />
                  </Button>
                </td>
              )}
              {isSelectOrder && (
                <td>
                  <Form.Label className="justify-content-center d-flex align-items-center mb-0">
                    <Form.Check
                      type="checkbox"
                      checked={selectedIds.has(item?.id)}
                      onChange={() =>
                        handleOrderCheckboxChange(
                          item?.id,
                          selectedIds,
                          toggleRow,
                        )
                      }
                    />
                  </Form.Label>
                </td>
              )}
              <td>
                {srNumber?.clickable ? (
                  <Button
                    className="btn-link btn-link-color"
                    onClick={() => showOrder(item?.id, srNumber?.events)}
                  >
                    {GetCurrentTableSRNo(
                      rowIndex,
                      Pagination?.current_page,
                      Pagination?.record_limit,
                    )}
                  </Button>
                ) : (
                  GetCurrentTableSRNo(
                    rowIndex,
                    Pagination?.current_page,
                    Pagination?.record_limit,
                  )
                )}
              </td>
              {RowData?.map((row, ind) => {
                if (!row?.isCollapsable) {
                  if (row?.type === "navigate") {
                    return (
                      <td key={ind}>
                        {EditAccess ? (
                          <Link
                            className="btn-link btn-link-color text-decoration-none"
                            to={`${AFTER_SALES_ORDERS_URL}/${item?.id}`}
                          >
                            <b className="tableBolanchor">
                              {item[row?.key] || "-"}
                            </b>
                          </Link>
                        ) : (
                          <b className="tableBolanchor">
                            {item[row?.key] || "-"}
                          </b>
                        )}
                      </td>
                    );
                  } else if (row?.type === "navigate_regular_order") {
                    return (
                      <td key={ind}>
                        {
                          <Link
                            className="btn-link btn-link-color text-decoration-none"
                            to={`${row?.navigate_url}/${item?.id}`}
                          >
                            <b className="tableBolanchor">
                              {item[row?.key] || "-"}
                            </b>
                          </Link>
                        }
                      </td>
                    );
                  } else if (row?.type === "order_details") {
                    return (
                      <td key={ind}>
                        <b
                          className="tableBolanchor"
                          onClick={() =>
                            OrderDetailsModal(
                              item.customer_identity.includes("WEB")
                                ? item?.order_id
                                : item?.id,
                            )
                          }
                        >
                          {item[row?.key] || "-"}
                        </b>
                      </td>
                    );
                  } else if (row?.type === "afs_order_details") {
                    return (
                      <td key={ind}>
                        <b
                          className="tableBolanchor"
                          onClick={() => AfsOrderDetailsModal(item?.id)}
                        >
                          {item[row?.key] || "-"}
                        </b>
                      </td>
                    );
                  } else if (row?.type === "invoice_details") {
                    return (
                      <td key={ind}>
                        {selfInfo?.user?.user_type === "super_admin" ? (
                          <>
                            {!item?.invoice_code ? (
                              "-"
                            ) : (
                              <b
                                className="tableBolanchor"
                                onClick={(e) =>
                                  callRegularInvoiceModal(e, item?.id)
                                }
                              >
                                {item?.invoice_code}
                              </b>
                            )}
                          </>
                        ) : (
                          <>
                            {item?.order_status === "AC_APPROVED" ? (
                              <b
                                className="tableBolanchor"
                                style={{ cursor: "default" }}
                              >
                                {item?.invoice_code}
                              </b>
                            ) : (
                              <React.Fragment>
                                {!item?.invoice_code ? (
                                  "-"
                                ) : (
                                  <b
                                    className="tableBolanchor"
                                    onClick={(e) =>
                                      callRegularInvoiceModal(e, item?.id)
                                    }
                                  >
                                    {item?.invoice_code}
                                  </b>
                                )}
                              </React.Fragment>
                            )}
                          </>
                        )}
                      </td>
                    );
                  } else if (row?.type === "label_self") {
                    return (
                      <td key={ind}>
                        {item?.id !== user_id ? item?.full_name : "You"}
                      </td>
                    );
                  } else if (row?.type === "label_user_type") {
                    return (
                      <td
                        style={{ width: "130px", textTransform: "capitalize" }}
                        key={ind}
                      >
                        {item[row?.key] === "regional_sales_team_asm"
                          ? "Assistant Sales Manager"
                          : item[row?.key] === "regional_sales_team_rm"
                            ? "Regional Manager"
                            : item[row?.key]?.replaceAll("_", " ")}
                      </td>
                    );
                  } else if (row?.type === "label_region_name") {
                    return (
                      <td key={ind}>
                        {item?.user_type === "regional_manager" ||
                        item?.user_type === "regional_sales_team_rm"
                          ? GetRegionName(item?.related_id)
                          : item?.user_type === "regional_sales_team_asm"
                            ? GetRegionName(item?.region_id)
                            : "-"}
                      </td>
                    );
                  } else if (row?.type === "label_get_from_franchise_data") {
                    return (
                      <td key={ind}>{item?.franchise_data?.franchise_name}</td>
                    );
                  } else if (row?.type === "label_get_from_product_data") {
                    return (
                      <td key={ind}>{item?.product_details?.product_name}</td>
                    );
                  } else if (row?.type === "date") {
                    return (
                      <td key={ind}>
                        {item[row?.key] !== null && item[row?.key] !== "None"
                          ? CommonDateTime(item[row?.key], "LL", "show")
                          : "-"}
                      </td>
                    );
                  } else if (row?.type === "months_show") {
                    return (
                      <td key={ind}>
                        {moment(
                          new Date(item?.scheme_date?.split("T")[0]),
                        ).format("MMMM")}
                      </td>
                    );
                  } else if (row?.type === "date_time") {
                    return (
                      <td key={ind}>
                        {CommonDateTimeCommon(item[row?.key], "desktop")}
                      </td>
                    );
                  } else if (row?.type === "date_time_erp") {
                    return (
                      <td key={ind}>
                        {DateConvertIntoReal(item[row?.key], "regular")}
                      </td>
                    );
                  } else if (row?.type === "date_time_process_date") {
                    return (
                      <td key={ind}>
                        {DateConvertIntoReal(item[row?.key], "12 hour")}
                      </td>
                    );
                  } else if (row?.type === "navigate_quotations") {
                    return (
                      <td key={ind}>
                        {EditAccess ? (
                          <Link
                            className="btn-link btn-link-color text-decoration-none"
                            to={`${QUOTATIONS_REPORT_DETAILS_URL}/${item?.id}`}
                          >
                            <b className="tableBolanchor">
                              {item[row?.key] || "-"}
                            </b>
                          </Link>
                        ) : (
                          <b className="tableBolanchor">
                            {item[row?.key] || "-"}
                          </b>
                        )}
                      </td>
                    );
                  } else if (
                    row?.type === "navigate_quotations_payment_approval"
                  ) {
                    return (
                      <td key={ind}>
                        {EditAccess ? (
                          <Link
                            className="btn-link btn-link-color text-decoration-none"
                            to={`${PAYMENT_APPROVAL_QUOTATIONS_REPORT_DETAILS_URL}/${item?.id}`}
                          >
                            <b className="tableBolanchor">
                              {item[row?.key] || "-"}
                            </b>
                          </Link>
                        ) : (
                          <b className="tableBolanchor">
                            {item[row?.key] || "-"}
                          </b>
                        )}
                      </td>
                    );
                  } else if (row?.type === "date") {
                    return (
                      <td key={ind}>
                        {item[row?.key] === null || item[row?.key] === "None"
                          ? "-"
                          : CommonDateTime(item[row?.key], "LL", "show")}
                      </td>
                    );
                  } else if (row?.type === "label_get_from_franchise") {
                    return (
                      <td key={ind}>
                        {GetFranchiseName(item[row?.key])?.name}
                      </td>
                    );
                  } else if (row?.type === "label_old_warehouse") {
                    return (
                      <td key={ind}>
                        {item?.is_resign ? item?.old_warehouse_name : "-"}
                      </td>
                    );
                  } else if (row?.type === "label_franchise_code") {
                    return (
                      <td key={ind}>
                        {item[row?.key]?.toString().includes("FC")
                          ? item[row?.key]?.replace("FC", "")
                          : item[row?.key]}
                      </td>
                    );
                  } else if (row?.type === "label_get_ship_warehouse") {
                    return (
                      <td key={ind}>{GetCurrentWarehouse(item[row?.key])}</td>
                    );
                  } else if (row?.type === "label_parent_id") {
                    return (
                      <td key={ind}>
                        {item?.is_distributor ? (
                          "Distributor"
                        ) : (
                          <>
                            {item[row?.key] === null ? "Dealer" : "Sub Dealer"}
                          </>
                        )}
                      </td>
                    );
                  } else if (row?.type === "label_redirect_location_url") {
                    return (
                      <td key={ind}>
                        {item[row?.key] !== null && item[row?.key] !== "" ? (
                          <a href={item[row?.key]} target="__blank">
                            <i className="bi bi-geo-alt"></i> Location
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                    );
                  } else if (row?.type === "shipping_manifest_link_download") {
                    return (
                      <td key={ind}>
                        {item[row?.key] !== null && item[row?.key] !== "" ? (
                          <a href={item[row?.key]} target="__blank">
                            <i className="bi bi-file-earmark-text"></i> Shipping
                            Manifest Link
                          </a>
                        ) : (
                          "-"
                        )}
                      </td>
                    );
                  } else if (
                    row?.type === "label_get_category_name_from_product"
                  ) {
                    return (
                      <td key={ind}>
                        {GetCategoryFrromProductsName(item[row?.key])}
                      </td>
                    );
                  } else if (row?.type === "label_capitalized") {
                    return (
                      <td key={ind} style={{ textTransform: "capitalize" }}>
                        {item[row?.key]}
                      </td>
                    );
                  } else if (row?.type === "label_get_from_list") {
                    return (
                      <td key={ind}>
                        {GetName(item[row?.key], row?.filterFrom)}
                      </td>
                    );
                  } else if (row?.type === "image") {
                    return (
                      <td key={ind}>
                        <AvatarSet
                          type={"product"}
                          url={item[row?.key]}
                          alt={"tableimg"}
                        />
                      </td>
                    );
                  } else if (row?.type === "invoice_modal_open_navigate") {
                    return (
                      <td key={ind}>
                        {EditAccess ? (
                          <>
                            {item[row?.key] !== null ? (
                              <b
                                className="tableBolanchor"
                                onClick={(e) =>
                                  callInvoiceModal(e, item?.id, "afs_order")
                                }
                              >
                                {item[row?.key] || "-"}
                              </b>
                            ) : (
                              <>{item[row?.key] || "-"}</>
                            )}
                          </>
                        ) : (
                          <>
                            {item[row?.key] !== null ? (
                              <b
                                className="tableBolanchor"
                                style={{ cursor: "default" }}
                              >
                                {item[row?.key] || "-"}
                              </b>
                            ) : (
                              <>{item[row?.key] || "-"}</>
                            )}
                          </>
                        )}
                      </td>
                    );
                  } else if (
                    row?.type === "invoice_regular_modal_open_navigate"
                  ) {
                    return (
                      <td key={ind}>
                        {EditAccess ? (
                          <b
                            className="tableBolanchor"
                            onClick={(e) =>
                              callInvoiceModal(e, item?.id, "regular_order")
                            }
                          >
                            {item[row?.key] || "-"}
                          </b>
                        ) : (
                          <b
                            className="tableBolanchor"
                            style={{ cursor: "default" }}
                          >
                            {item[row?.key] || "-"}
                          </b>
                        )}
                      </td>
                    );
                  } else if (row?.type === "fulfillment_tat") {
                    return (
                      <td key={ind}>
                        {item[row?.key] === null || item[row?.key] === "" ? (
                          "-"
                        ) : (
                          <td key={ind} className="">
                            {TimeSenseSigned(item[row?.key])}
                          </td>
                        )}
                      </td>
                    );
                  } else if (row?.type === "pending_since") {
                    return <td key={ind}>{TimeSense(item[row?.key])}</td>;
                  } else if (row?.type === "label_opening_balance") {
                    return <td key={ind}>0</td>;
                  } else if (row?.type === "label_price") {
                    return (
                      <td key={ind}>{AmountNumberFormat(item[row?.key])}</td>
                    );
                  } else if (row?.type === "label_invoice_no_purchase_list") {
                    return (
                      <td key={ind}>
                        {item?.order === undefined
                          ? "-"
                          : item?.order?.invoice_code}
                      </td>
                    );
                  } else if (row?.type === "label_invoice_date_list") {
                    return (
                      <td key={ind}>
                        {item?.order === undefined
                          ? "-"
                          : CommonDateTime(
                              item?.order?.invoice_at,
                              "LL",
                              "show",
                            )}
                      </td>
                    );
                  } else if (row?.type === "label_closing_balance") {
                    return (
                      <td key={ind}>
                        {AmountNumberFormat(
                          parseFloat(item.total_credit) -
                            parseFloat(item.total_debit),
                        )}
                      </td>
                    );
                  } else if (row?.type === "label_get_from_list") {
                    return (
                      <td key={ind}>
                        {GetName(item[row?.key], row?.filterFrom)}
                      </td>
                    );
                  } else if (row?.type === "Status_sales_person_performance") {
                    return <td key={ind}>{getStatus(item)}</td>;
                  } else if (row?.type === "label_order_status") {
                    return <td key={ind}>{CommonStatus(item[row?.key])}</td>;
                  } else if (row?.type === "label_cancel_status") {
                    return (
                      <td key={ind}>{CancelStageStatus(item[row?.key])}</td>
                    );
                  } else if (
                    row?.type === "label_get_from_list_summary_details"
                  ) {
                    return (
                      <td key={ind}>
                        <Button
                          className="btn-link btn-link-color text-decoration-none"
                          onClick={() =>
                            showSummaryDetails(item, "list_summary")
                          }
                        >
                          <b className="tableBolanchor">
                            {GetName(item[row?.key], row?.filterFrom)}
                          </b>
                        </Button>
                      </td>
                    );
                  } else if (
                    row?.type ===
                    "label_get_from_list_erp_general_summary_details"
                  ) {
                    return (
                      <td key={ind}>
                        <Button
                          className="btn-link btn-link-color text-decoration-none"
                          onClick={() =>
                            showSummaryDetails(item, "erp_list_summary")
                          }
                        >
                          <b className="tableBolanchor">
                            {GetName(item[row?.key], row?.filterFrom)}
                          </b>
                        </Button>
                      </td>
                    );
                  } else if (row?.type === "label_get_state_from_pincodes") {
                    return (
                      <td key={ind}>
                        {
                          GetPincodeSearch(item[row?.key], row?.filterFrom)
                            ?.state_name
                        }
                      </td>
                    );
                  } else if (row?.type === "label_get_gst_from_pincodes") {
                    return (
                      <td key={ind}>
                        {
                          GetPincodeSearch(item[row?.key], row?.filterFrom)
                            ?.gst_code
                        }
                      </td>
                    );
                  } else if (row?.type === "label_get_from_fscode_list") {
                    return (
                      <td key={ind}>
                        {GetAFSporductName(item[row?.key], row?.filterFrom)}
                      </td>
                    );
                  } else if (
                    row?.type === "label_franchise_last_three_orders"
                  ) {
                    return (
                      <td key={ind}>
                        {item[row?.key] === 0 ? (
                          item[row?.key]
                        ) : (
                          <b
                            className="tableBolanchor"
                            onClick={() => FranchiseLastThreeOrders(item)}
                          >
                            {item[row?.key]}
                          </b>
                        )}
                      </td>
                    );
                  } else if (row?.type === "city_label_get_from_warehouse") {
                    return (
                      <td key={ind}>
                        {GetCityName(item[row?.key], row?.filterFrom)}
                      </td>
                    );
                  } else if (row?.type === "state_label_get_from_warehouse") {
                    return (
                      <td key={ind}>
                        {GetStateName(item[row?.key], row?.filterFrom)}
                      </td>
                    );
                  } else if (row?.type === "status_user_verification_active") {
                    return (
                      <td key={ind}>
                        {item?.user_type === "sale_franchise_person" ? (
                          item?.user_verification ? (
                            <Badge bg="success">Yes</Badge>
                          ) : (
                            <Badge bg="danger">No</Badge>
                          )
                        ) : (
                          "-"
                        )}
                      </td>
                    );
                  } else if (row?.type === "erp_sync_status") {
                    return (
                      <td key={ind}>
                        <ErpSyncStatus
                          status={item?.erp_sync_status}
                          reason={item?.erp_sync_error}
                        />
                      </td>
                    );
                  } else if (row?.type === "status_yes_no") {
                    return (
                      <td key={ind}>
                        {item[row?.key] ? (
                          <Badge bg="success">Yes</Badge>
                        ) : (
                          <Badge bg="danger">No</Badge>
                        )}
                      </td>
                    );
                  } else if (row?.type === "status_Docket_EWB") {
                    return (
                      <td key={ind}>
                        {item[row?.key] ? (
                          <Badge bg="success">Docket Number</Badge>
                        ) : (
                          <Badge bg="danger">EWB Number</Badge>
                        )}
                      </td>
                    );
                  } else if (row?.type === "status") {
                    return (
                      <td key={ind}>
                        {item[row?.key] === null || item[row?.key] === "" ? (
                          <Badge bg="danger">Failed</Badge>
                        ) : (
                          <Badge bg="success">Success</Badge>
                        )}
                      </td>
                    );
                  } else if (row?.type === "warehouse_type_category_custom") {
                    return (
                      <td key={ind}>{GetWarehouseTypeName(item[row?.key])}</td>
                    );
                  } else if (row?.type === "status_active") {
                    return (
                      <td key={ind}>
                        {item[row?.key] ? (
                          <Badge bg="success">Active</Badge>
                        ) : (
                          <Badge bg="danger">Inactive</Badge>
                        )}
                      </td>
                    );
                  } else if (
                    row?.type === "label_erp_invoice_delivery_note_api_status"
                  ) {
                    return (
                      <td key={ind}>
                        {item[row?.key] === null || item[row?.key] === "" ? (
                          <Badge bg="danger">Failed</Badge>
                        ) : (
                          <Badge bg="success">Success</Badge>
                        )}
                      </td>
                    );
                  } else if (row?.type === "status_franchise_active") {
                    return (
                      <td key={ind}>
                        {item?.is_active && item?.order_count === 0 ? (
                          <>
                            {item?.order_count === 0 && (
                              <Badge className="not_billed_orange" bg="danger">
                                Not Billed
                              </Badge>
                            )}
                          </>
                        ) : item?.is_active && item?.order_count > 0 ? (
                          <>
                            {item?.is_active ? (
                              <Badge bg="success">Active</Badge>
                            ) : (
                              <Badge bg="danger">Inactive</Badge>
                            )}
                          </>
                        ) : (
                          <>
                            {item?.is_active ? (
                              <Badge bg="success">Active</Badge>
                            ) : (
                              <Badge bg="danger">Inactive</Badge>
                            )}
                          </>
                        )}
                      </td>
                    );
                  } else if (row?.type === "status_frame_active") {
                    return (
                      <td key={ind}>
                        {item[row?.key] ? (
                          <Badge bg="success">Yes</Badge>
                        ) : (
                          <Badge bg="danger">No</Badge>
                        )}
                      </td>
                    );
                  } else if (row?.type === "status_sold_unsold") {
                    return (
                      <td key={ind}>
                        {item[row?.key] === "SOLD" ? (
                          <Badge bg="success">Sold</Badge>
                        ) : (
                          <Badge bg="danger">Un-Sold</Badge>
                        )}
                      </td>
                    );
                  } else if (row?.type === "hyper_link_shipment_url") {
                    return (
                      <td key={ind}>
                        {item[row?.key] === null ? (
                          "-"
                        ) : item?.shipment_url === null ? (
                          item[row?.key]
                        ) : (
                          <a href={item?.shipment_url} target="__blank">
                            {item[row?.key] ? item[row?.key] : "-"}
                          </a>
                        )}{" "}
                      </td>
                    );
                  } else if (row?.type === "label_day_price") {
                    return (
                      <td key={ind}>
                        {item[row?.key] === null ? "0" : item[row?.key]}
                      </td>
                    );
                  } else if (row?.type === "label_day_ammount") {
                    return (
                      <td key={ind}>
                        ₹
                        {AmountNumberFormat(
                          item[row?.key] === null ? "0" : item[row?.key],
                        )}
                      </td>
                    );
                  } else if (row?.type === "label_Criticality") {
                    const get_color = getColor(item);
                    return (
                      <td key={ind}>
                        <span
                          className={`px-2 py-1 rounded ${get_color.color_code}`}
                        >
                          {get_color.text}
                        </span>
                      </td>
                    );
                  } else if (row?.type === "label_order_status") {
                    return <td key={ind}>{CommonStatus(item[row?.key])}</td>;
                  } else if (row?.type === "pod_link_navigate") {
                    return (
                      <td key={ind}>
                        {item[row?.key] === "" || item[row?.key] === null ? (
                          "-"
                        ) : (
                          <>
                            {item[row?.key]?.includes(
                              process.env.REACT_APP_BASE_URL,
                            ) ? (
                              <button
                                className="btn btn-link"
                                onClick={() =>
                                  FileDownload(item?.docket_slip, accessToken)
                                }
                              >
                                <i className="bi bi-download"></i>
                              </button>
                            ) : (
                              <a href={item[row?.key]} target="__blank">
                                <i className="bi bi-download"></i>
                              </a>
                            )}
                          </>
                        )}
                      </td>
                    );
                  } else if (row?.type === "label_E_Invoice_error_view") {
                    return (
                      <td key={ind}>
                        <Button
                          className="btn edittable btn btn-primary"
                          onClick={() => HandleErrorShow(item)}
                        >
                          <i className="bi bi-eye"></i>
                        </Button>
                      </td>
                    );
                  } else if (row?.type === "label_Generate_Invoice") {
                    return (
                      <td key={ind}>
                        {item?.invoice_no === null ? (
                          "-"
                        ) : (
                          <Button
                            className="btn edittable btn btn-primary"
                            onClick={() => GenerateInvoicFunction(item)}
                          >
                            <i className="bi bi-eye"></i>
                          </Button>
                        )}
                      </td>
                    );
                  } else if (row?.type === "label_Invoiceable_Qty") {
                    return (
                      <td key={ind}>
                        {displayZeroIfNegative(
                          item?.inward_qty -
                            item?.transfer_qty -
                            item?.invoiceable_qty,
                        )}
                      </td>
                    );
                  } else if (row?.type === "label_product_stock") {
                    return (
                      <td key={ind}>
                        {GetProductSTockValue(
                          item?.product_id,
                          item?.inward_qty,
                          item?.transfer_qty,
                        )}
                      </td>
                    );
                  } else if (row?.type === "quotation_status_type") {
                    return (
                      <td key={ind}>
                        {QuotationsStatus(item[row?.key], "badge")}
                      </td>
                    );
                  } else if (row?.type === "quotation_erp_status_type") {
                    return (
                      <td key={ind}>
                        {item[row?.key] === null || item[row?.key] === "" ? (
                          <Badge bg="danger">Failed</Badge>
                        ) : (
                          <Badge bg="success">Success</Badge>
                        )}
                      </td>
                    );
                  } else if (row?.type === "label_stock_transfer") {
                    return (
                      <td key={ind}>
                        {item[row?.key] === 0 || item[row?.key] < 0
                          ? "0"
                          : item[row?.key]}
                      </td>
                    );
                  } else if (row?.type === "label_Type_Of_Transaction") {
                    return (
                      <td key={ind}>
                        <b>{item[row?.key] || "-"}</b>
                      </td>
                    );
                  } else if (row?.type === "label_docket_number") {
                    return (
                      <td key={ind}>
                        {item?.docket_number === null ? (
                          "-"
                        ) : item?.shipment_url === null ||
                          item?.shipment_url === "" ? (
                          item?.docket_number
                        ) : (
                          <a href={item?.shipment_url} target="__blank">
                            {item?.docket_number ? item?.docket_number : "-"}
                          </a>
                        )}
                      </td>
                    );
                  } else if (row?.type === "available_balance_label") {
                    return (
                      <td key={ind}>
                        {AmountNumberFormat(
                          parseFloat(
                            (isNaN(item?.credit_limit) &&
                            item?.credit_limit === "None"
                              ? 0
                              : item?.credit_limit) -
                              (isNaN(item?.outstanding) &&
                              item?.outstanding === "None"
                                ? 0
                                : item?.outstanding),
                          ),
                        )}
                      </td>
                    );
                  } else if (row?.type === "label_check_none_empty") {
                    return (
                      <td key={ind}>
                        {item[row?.key] === "None" ? "-" : item[row?.key]}
                      </td>
                    );
                  } else if (row?.type === "label_check_none_number") {
                    return (
                      <td key={ind}>
                        {item[row?.key] === "None"
                          ? "0"
                          : AmountNumberFormat(item[row?.key])}
                      </td>
                    );
                  } else if (row?.type === "encrypt_email") {
                    return (
                      <td key={ind}>
                        {item[row?.key] === "None"
                          ? "-"
                          : maskString(item[row?.key], "email")}
                      </td>
                    );
                  } else if (row?.type === "encrypt_mobile") {
                    return (
                      <td key={ind}>
                        {item[row?.key] === "None"
                          ? "-"
                          : maskString(item[row?.key], "mobile")}
                      </td>
                    );
                  } else if (row?.type === "label_with_downloadable") {
                    return (
                      <td key={ind}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                          }}
                        >
                          <div
                            style={{
                              float: "left",
                              width: "auto",
                              marginRight: "5px",
                            }}
                          >
                            {item?.frame_number}
                          </div>
                          {item?.frame_number_image !== null && (
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 100 }}
                              overlay={
                                <Tooltip
                                  style={{ position: "fixed" }}
                                  id="button-tooltip"
                                  {...props}
                                >
                                  Download Frame Image
                                </Tooltip>
                              }
                            >
                              <Button
                                className="btn edittable edittableretry btn btn-primary"
                                style={{ float: "left" }}
                                onClick={() =>
                                  FileDownload(
                                    item?.frame_number_image,
                                    accessToken,
                                  )
                                }
                              >
                                <Image src={DownloadFile} alt="edit" />
                              </Button>
                            </OverlayTrigger>
                          )}
                        </div>
                      </td>
                    );
                  } else {
                    return <td key={ind}>{item[row?.key] || "-"}</td>;
                  }
                }
              })}
              {ActionPreviewState?.isShow && (
                <CommonPreviewButton data={item} />
              )}
              {EditAccess && ActionColumn?.isShow && (
                <CommonButton data={item} />
              )}
              {ActionColumnRead?.isShow && <CommonButtonRead data={item} />}
            </tr>
            {isTableAllow && (
              <Collapse in={activeTableDetails === item?.id ? true : false}>
                <tr
                  className="tablecollapsewraps"
                  id={"tablecollpase" + item?.id}
                >
                  <td colSpan="9" style={{ padding: "0px" }}>
                    <Table className="table">
                      <tbody>
                        {RowData?.map((row, ind) => {
                          if (row?.isCollapsable) {
                            if (row?.type === "label_get_brand_name") {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>{GetBrandName(item[row?.key])}</td>
                                </tr>
                              );
                            } else if (
                              row?.type === "label_get_category_name"
                            ) {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>{GetCategoryName(item[row?.key])}</td>
                                </tr>
                              );
                            } else if (
                              row?.type === "schemes_App_group_details"
                            ) {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>
                                    {item?.app_group?.split(",")?.length > 0 ? (
                                      <ul
                                        style={{
                                          marginBottom: "0px",
                                          paddingLeft: "15px",
                                        }}
                                      >
                                        {item?.app_group
                                          ?.split(",")
                                          ?.map((elx, index) => {
                                            return (
                                              <li
                                                style={{
                                                  fontSize: "13px",
                                                  marginBottom: "3px",
                                                }}
                                                key={index}
                                              >
                                                {elx}
                                              </li>
                                            );
                                          })}
                                      </ul>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                </tr>
                              );
                            } else if (
                              row?.type === "schemes_product_details"
                            ) {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>
                                    {item?.product_details?.length > 0 ? (
                                      <ul
                                        style={{
                                          marginBottom: "0px",
                                          paddingLeft: "15px",
                                        }}
                                      >
                                        {item?.product_details?.map(
                                          (elx, index) => {
                                            return (
                                              <li
                                                style={{
                                                  fontSize: "13px",
                                                  marginBottom: "3px",
                                                }}
                                                key={index}
                                              >
                                                {elx?.product_name} - ({" "}
                                                {elx?.product_code} )
                                              </li>
                                            );
                                          },
                                        )}
                                      </ul>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                </tr>
                              );
                            } else if (row?.type === "payment_link_label") {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>
                                    {EditAccess ? (
                                      <React.Fragment>
                                        {item[row?.key] === null ? (
                                          "-"
                                        ) : (
                                          <React.Fragment>
                                            {row?.isDisable ? (
                                              item[row?.key]
                                            ) : (
                                              <>
                                                <a
                                                  href={item[row?.key]}
                                                  id={"payment_link" + item?.id}
                                                  style={{ color: "#00f" }}
                                                  target="__blank"
                                                >
                                                  {item[row?.key]}
                                                </a>
                                                <Button
                                                  className={
                                                    CopyUrl?.id ===
                                                    "payment_link" + item?.id
                                                      ? "btn btn-copy-link active"
                                                      : "btn btn-copy-link"
                                                  }
                                                  onClick={() =>
                                                    PaymentLinkCompy(
                                                      "payment_link" + item?.id,
                                                    )
                                                  }
                                                >
                                                  <i className="bi bi-copy"></i>{" "}
                                                  {CopyUrl?.id ===
                                                  "payment_link" + item?.id
                                                    ? CopyUrl?.label
                                                    : "Copy Link"}
                                                </Button>
                                              </>
                                            )}
                                          </React.Fragment>
                                        )}
                                      </React.Fragment>
                                    ) : (
                                      <React.Fragment style={{ color: "red" }}>
                                        Don't have permission to make a payment.
                                      </React.Fragment>
                                    )}
                                  </td>
                                </tr>
                              );
                            } else if (
                              row?.type ===
                              "payment_Attachment_preview_download"
                            ) {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>
                                    {item?.payment_slip === null ? (
                                      "-"
                                    ) : (
                                      <React.Fragment>
                                        <a
                                          href={
                                            FILE_AUTH_URL +
                                            "view/file/" +
                                            item?.payment_slip?.id
                                          }
                                          style={{ color: "#00f" }}
                                          target="__blank"
                                        >
                                          {item?.payment_slip?.original_name}
                                        </a>
                                        <Button
                                          className="btn btn-copy-link"
                                          onClick={() =>
                                            FileDownload(
                                              item?.payment_slip?.id,
                                              accessToken,
                                            )
                                          }
                                        >
                                          <i className="bi bi-download"></i>{" "}
                                          Download file
                                        </Button>
                                      </React.Fragment>
                                    )}
                                  </td>
                                </tr>
                              );
                            } else if (row?.type === "date") {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>
                                    {item[row?.key] === null ||
                                    item[row?.key] === "None"
                                      ? "-"
                                      : CommonDateTime(
                                          item[row?.key],
                                          "LL",
                                          "show",
                                        )}
                                  </td>
                                </tr>
                              );
                            } else if (
                              row?.type === "city_label_get_from_warehouse"
                            ) {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>
                                    {GetCityName(
                                      item[row?.key],
                                      row?.filterFrom,
                                    )}
                                  </td>
                                </tr>
                              );
                            } else if (
                              row?.type === "state_label_get_from_warehouse"
                            ) {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>
                                    {GetStateName(
                                      item[row?.key],
                                      row?.filterFrom,
                                    )}
                                  </td>
                                </tr>
                              );
                            } else if (row?.type === "label_get_from_list") {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>
                                    {GetName(item[row?.key], row?.filterFrom)}
                                  </td>
                                </tr>
                              );
                            } else if (row?.type === "erp_sync_status") {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>
                                    <ErpSyncStatus
                                      status={item?.erp_sync_status}
                                      reason={item?.erp_sync_error}
                                    />
                                  </td>
                                </tr>
                              );
                            } else if (row?.type === "status_yes_no") {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>
                                    {item[row?.key] ? (
                                      <Badge bg="success">Yes</Badge>
                                    ) : (
                                      <Badge bg="danger">No</Badge>
                                    )}
                                  </td>
                                </tr>
                              );
                            } else if (row?.type === "label_point_images") {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>
                                    <ul style={{ margin: "0px" }}>
                                      {item[row?.key] === null
                                        ? "-"
                                        : JSON.parse(
                                            item[row?.key]?.replace(/'/g, '"'),
                                          )?.map((elm, index) => {
                                            return <li key={index}>{elm}</li>;
                                          })}
                                    </ul>
                                  </td>
                                </tr>
                              );
                            } else if (row?.type === "label_reference_images") {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>
                                    {item[row?.key] === null ? (
                                      "-"
                                    ) : (
                                      <ul
                                        className="uploade_images_wrapper_list"
                                        style={{ margin: "0px" }}
                                      >
                                        {JSON.parse(
                                          item[row?.key]?.replace(/'/g, '"'),
                                        )?.map((elm, index) => {
                                          return (
                                            <li key={index}>
                                              <div className="wrapps_upload_img">
                                                <span>
                                                  Range : {elm?.range}
                                                </span>
                                                <div
                                                  className="image_preview_wraps"
                                                  key={index}
                                                >
                                                  <Image
                                                    src={
                                                      FILE_AUTH_URL +
                                                      elm?.images?.view_file_url
                                                    }
                                                    onError={(e) =>
                                                      (e.target.src =
                                                        DefaultImage)
                                                    }
                                                    alt="image_preiew"
                                                  />
                                                </div>
                                              </div>
                                            </li>
                                          );
                                        })}
                                      </ul>
                                    )}
                                  </td>
                                </tr>
                              );
                            } else if (row?.type === "payment_paid_details") {
                              if (item?.quotation_status === "PAID") {
                                return (
                                  <React.Fragment key={ind}>
                                    <tr>
                                      <th style={{ width: "20%" }}>
                                        Payment ID
                                      </th>
                                      <td>
                                        {item?.payment_id === null
                                          ? "-"
                                          : item?.payment_id}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th style={{ width: "20%" }}>
                                        TXN ID/Ref No
                                      </th>
                                      <td>
                                        {item?.txn_id === null
                                          ? "-"
                                          : item?.txn_id}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th style={{ width: "20%" }}>
                                        Payment Date
                                      </th>
                                      <td>
                                        {CommonDateTime(
                                          item?.payment_date,
                                          "LL",
                                          "show",
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th style={{ width: "20%" }}>
                                        Payment Attachment
                                      </th>
                                      <td>
                                        {item?.payment_slip === null ? (
                                          "-"
                                        ) : (
                                          <React.Fragment>
                                            <a
                                              href={
                                                FILE_AUTH_URL +
                                                "view/file/" +
                                                item?.payment_slip?.id
                                              }
                                              style={{ color: "#00f" }}
                                              target="__blank"
                                            >
                                              {
                                                item?.payment_slip
                                                  ?.original_name
                                              }
                                            </a>
                                            <Button
                                              className="btn btn-copy-link"
                                              onClick={() =>
                                                FileDownload(
                                                  item?.payment_slip?.id,
                                                  accessToken,
                                                )
                                              }
                                            >
                                              <i className="bi bi-download"></i>{" "}
                                              Download file
                                            </Button>
                                          </React.Fragment>
                                        )}
                                      </td>
                                    </tr>
                                    <tr>
                                      <th style={{ width: "20%" }}>
                                        Payment Mode
                                      </th>
                                      <td>
                                        {item?.payment_mode === null
                                          ? "-"
                                          : item?.payment_mode}
                                      </td>
                                    </tr>
                                  </React.Fragment>
                                );
                              }
                            } else if (row?.type === "labelOrderTypeFoShow") {
                              return (
                                <React.Fragment key={ind}>
                                  {/* <tr>
                                                    <th style={{ width: "20%" }}>Wallet Balance</th>
                                                    <td>{AmountNumberFormat(GetCurrentOrderRate(item)?.Wallet_balance)}</td>
                                                </tr>
                                                <tr>
                                                    <th style={{ width: "20%" }}>Credit Limit</th>
                                                    <td>{AmountNumberFormat(GetCurrentOrderRate(item)?.credit_limit)}</td>
                                                </tr> */}
                                  <tr>
                                    <th style={{ width: "20%" }}>
                                      Erp Credit Limit
                                    </th>
                                    <td>
                                      {AmountNumberFormat(
                                        GetCurrentOrderRate(item)
                                          ?.erp_credit_limit,
                                      )}
                                    </td>
                                  </tr>
                                  <tr>
                                    <th style={{ width: "20%" }}>
                                      Erp Outstanding
                                    </th>
                                    <td>
                                      {AmountNumberFormat(
                                        GetCurrentOrderRate(item)
                                          ?.erp_outstanding,
                                      )}
                                    </td>
                                  </tr>
                                </React.Fragment>
                              );
                            } else if (
                              row?.type === "Attachments_SoApprovals"
                            ) {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>Attachments</th>
                                  <td>
                                    {item?.attachments !== null ? (
                                      <ul className="fileuploadListytable">
                                        {item?.attachments?.map(
                                          (elm, index) => {
                                            return (
                                              <li key={index}>
                                                <a
                                                  href={
                                                    process.env
                                                      .REACT_APP_BASE_URL +
                                                    "file/" +
                                                    elm?.view_file_url
                                                  }
                                                  download={
                                                    elm?.attachment_name
                                                  }
                                                  target="__blank"
                                                >
                                                  <i className="bi bi-file-earmark-text"></i>{" "}
                                                  {elm?.attachment_name}{" "}
                                                  <i className="bi bi-download downloadIcomn"></i>
                                                </a>
                                              </li>
                                            );
                                          },
                                        )}
                                      </ul>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                </tr>
                              );
                            } else if (row?.type === "Attachments") {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>Attachments</th>
                                  <td>
                                    {item?.attachments !== null && (
                                      <ul className="fileuploadListytable">
                                        {item?.attachments?.map(
                                          (elm, index) => {
                                            return (
                                              <li key={index}>
                                                <a
                                                  href={
                                                    process.env
                                                      .REACT_APP_BASE_URL +
                                                    "file/" +
                                                    elm?.view_file_url
                                                  }
                                                  download={
                                                    elm?.attachment_name
                                                  }
                                                  target="__blank"
                                                >
                                                  <i className="bi bi-file-earmark-text"></i>{" "}
                                                  {elm?.attachment_name}{" "}
                                                  <i className="bi bi-download downloadIcomn"></i>
                                                </a>
                                              </li>
                                            );
                                          },
                                        )}
                                      </ul>
                                    )}
                                    {item?.attachments !== null &&
                                      OrderList?.uni_com_invoice_list?.filter(
                                        (elm__) =>
                                          elm__?.order_id === item?.id &&
                                          item?.order_type === "AO",
                                      )?.length > 0 && <br />}
                                    {OrderList?.uni_com_invoice_list?.filter(
                                      (elm__) =>
                                        elm__?.order_id === item?.id &&
                                        item?.order_type === "AO",
                                    )?.length > 0 &&
                                      OrderList?.uni_com_invoice_list?.map(
                                        (elm__, index) => {
                                          if (
                                            elm__?.order_id === item?.id &&
                                            item?.order_type === "AO"
                                          ) {
                                            return (
                                              <React.Fragment key={index}>
                                                {elm__?.invoiceCode !== null &&
                                                  item?.uni_code !== null && (
                                                    <a
                                                      key={index}
                                                      className="btn btn_downloadmain anchorDownoad"
                                                      onClick={() => {
                                                        MarketPlaceInvocie(
                                                          elm__?.invoiceCode,
                                                          item?.uni_code,
                                                        );
                                                      }}
                                                    >
                                                      <i className="bi bi-file-earmark-text"></i>{" "}
                                                      Market place invoice
                                                    </a>
                                                  )}
                                              </React.Fragment>
                                            );
                                          }
                                        },
                                      )}
                                    {OrderList?.uni_com_invoice_list?.filter(
                                      (elm__) =>
                                        elm__?.order_id === item?.id &&
                                        item?.order_type === "AO",
                                    )?.length > 0 &&
                                      item?.uni_shipment_url !== null && <br />}
                                    {item?.uni_shipment_url !== null && (
                                      <a
                                        href={item?.uni_shipment_url}
                                        className="btn btn_downloadmain anchorDownoad"
                                        download={item?.uni_shipment_url}
                                        target="__blank"
                                      >
                                        <i className="bi bi-file-earmark-text"></i>{" "}
                                        Shipping label
                                      </a>
                                    )}
                                  </td>
                                </tr>
                              );
                            } else if (row?.type === "label_order_status") {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>{CommonStatus(item[row?.key])}</td>
                                </tr>
                              );
                            } else if (
                              row?.type === "label_Additional_Status"
                            ) {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>
                                    {item[row?.key] === null ? (
                                      <Badge bg="success">Regular Order</Badge>
                                    ) : item["order_source"] === "Website" ? (
                                      <Badge bg="success">
                                        Website Payment Pending
                                      </Badge>
                                    ) : (
                                      <Badge bg="primary">
                                        Replacement Order
                                      </Badge>
                                    )}
                                  </td>
                                </tr>
                              );
                            } else if (row?.type === "label_day_ammount") {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td key={ind}>
                                    ₹
                                    {AmountNumberFormat(
                                      item[row?.key] === null
                                        ? "0"
                                        : item[row?.key],
                                    )}
                                  </td>
                                </tr>
                              );
                            } else if (row?.type === "categories_tables") {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>
                                    Category List
                                  </th>
                                  <td style={{ padding: "0px" }}>
                                    <Table
                                      id="MarketingCamaognsCategory"
                                      className="table Bike_Condition"
                                    >
                                      <thead>
                                        <tr>
                                          <th></th>
                                          <th>Category Name</th>
                                          <th>Images</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {item[row?.key]?.map((cat, indexx) => {
                                          return (
                                            <tr key={indexx}>
                                              <td></td>
                                              <td id="category_names">
                                                {cat?.category_name}
                                              </td>
                                              <td>
                                                <ul
                                                  style={{
                                                    margin: "0px",
                                                    paddingLeft: "12px",
                                                  }}
                                                >
                                                  {cat?.uploaded_files?.map(
                                                    (elm, indexxx) => {
                                                      const Image_ID =
                                                        elm?.file?.split(
                                                          "/",
                                                        )[2];
                                                      return (
                                                        <li
                                                          key={indexxx}
                                                          style={{
                                                            fontSize: "14px",
                                                            marginBottom: "5px",
                                                          }}
                                                        >
                                                          {elm?.file_name}
                                                          <i
                                                            className="bi bi-download"
                                                            style={{
                                                              cursor: "pointer",
                                                              margin:
                                                                "0 0 0 5px",
                                                            }}
                                                            onClick={() =>
                                                              FileDownload(
                                                                Image_ID,
                                                                accessToken,
                                                              )
                                                            }
                                                          ></i>
                                                        </li>
                                                      );
                                                    },
                                                  )}
                                                </ul>
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </Table>
                                  </td>
                                </tr>
                              );
                            } else if (row?.type === "label_dangerousHtml") {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td
                                    dangerouslySetInnerHTML={{
                                      __html: item[row?.key] || "-",
                                    }}
                                  ></td>
                                </tr>
                              );
                            } else if (row?.type === "label_mails") {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>
                                    <ul
                                      style={{
                                        margin: "0px",
                                        paddingLeft: "18px",
                                      }}
                                    >
                                      {item[row?.key]
                                        ?.split(",")
                                        ?.map((elmxs, index) => {
                                          return <li key={index}>{elmxs}</li>;
                                        })}
                                    </ul>
                                  </td>
                                </tr>
                              );
                            } else if (row?.type === "shipment_logs_type") {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>
                                    {item?.shipment_logs?.length === 0 ? (
                                      "-"
                                    ) : (
                                      <>
                                        <ul
                                          style={{
                                            margin: "0px",
                                            paddingLeft: "18px",
                                          }}
                                        >
                                          {item?.shipment_logs?.map(
                                            (elmxs, index) => {
                                              return (
                                                <li key={index}>
                                                  {elmxs?.status} &nbsp;&nbsp; -
                                                  &nbsp;&nbsp;{" "}
                                                  {CommonDateTime(
                                                    elmxs?.created_at,
                                                    "LL",
                                                    "show",
                                                  )}
                                                </li>
                                              );
                                            },
                                          )}
                                        </ul>
                                      </>
                                    )}
                                  </td>
                                </tr>
                              );
                            } else {
                              return (
                                <tr key={ind}>
                                  <th style={{ width: "20%" }}>{row?.label}</th>
                                  <td>{item[row?.key] || "-"}</td>
                                </tr>
                              );
                            }
                          }
                        })}
                      </tbody>
                    </Table>
                  </td>
                </tr>
              </Collapse>
            )}
          </React.Fragment>
        );
      })}
      {OrderList?.list?.length === 0 && (
        <tr>
          <td style={{ textAlign: "center" }} colSpan={CurrentColspan}>
            List not found
          </td>
        </tr>
      )}

      {isTotalAndGrand?.isShow && (
        <React.Fragment>
          {isTotalAndGrand?.filterType === "Debit-credit-note-report" ? (
            <React.Fragment>
              <tr className="totaltd">
                <th colSpan={isTotalAndGrand?.colSpan} className="text-center">
                  Page total
                </th>
                <td>
                  {AmountNumberFormat(
                    TotalTableCount(OrderList?.list, "credit_amt"),
                  )}
                </td>
                <td colSpan={isTotalAndGrand?.lastColspan}>
                  {AmountNumberFormat(
                    TotalTableCount(OrderList?.list, "debit_amt"),
                  )}
                </td>
              </tr>
              <tr className="totaltd">
                <th colSpan={isTotalAndGrand?.colSpan} className="text-center">
                  Grand total
                </th>
                <td>{AmountNumberFormat(OrderList?.grand_credit)}</td>
                <td colSpan={isTotalAndGrand?.lastColspan}>
                  {AmountNumberFormat(OrderList?.grand_debit)}
                </td>
              </tr>
            </React.Fragment>
          ) : isTotalAndGrand?.filterType === "Stock-Level" ? (
            <React.Fragment>
              <tr className="totaltd">
                <th
                  colSpan={isTotalAndGrand?.colSpan}
                  style={{ textAlign: "center" }}
                >
                  Page Total
                </th>
                <td>{TotalTableCount(OrderList?.list, "inward_qty")}</td>
                <td>{TotalTableCount(OrderList?.list, "transfer_qty")}</td>
                {/* <td>{TotalTableCount(OrderList?.list, "inward_qty - invoiceable_qty")}</td> */}
                <td>
                  {TotalTableCount(
                    OrderList?.list,
                    "inward_qty - transfer_qty",
                  )}
                </td>
                <td>{TotalTableCount(OrderList?.list, "TotalProduct")}</td>
              </tr>
              <tr className="totaltd">
                <th
                  colSpan={isTotalAndGrand?.colSpan}
                  style={{ textAlign: "center" }}
                >
                  Grand Total
                </th>
                <td>{OrderList?.grand?.grand_in}</td>
                <td>{OrderList?.grand?.grand_tran}</td>
                {/* <td>{OrderList?.grand?.grand_inv}</td> */}
                <td>{OrderList?.grand?.grand_bal}</td>
                <td>{OrderList?.grand?.grand_val}</td>
              </tr>
            </React.Fragment>
          ) : (
            <React.Fragment></React.Fragment>
          )}
        </React.Fragment>
      )}

      {showModal?.open && (
        <Modal show={showModal?.open} onHide={onClose} className="commonModal">
          <Modal.Header className="border-bottom-0 bb-0 pb-0" closeButton>
            <Modal.Title className="h5">
              {showModal?.title} <span className="text-danger">*</span>
            </Modal.Title>
          </Modal.Header>
          <div className="p-3">
            <FormControl
              value={showModal?.Reason}
              onChange={(e) => {
                setShowModal({
                  ...showModal,
                  Reason: e?.target?.value,
                });
              }}
              placeholder="Enter a reason"
              as="textarea"
            />
            {errorReason !== "" && (
              <small className="text-danger">{errorReason}</small>
            )}
          </div>
          <div className="d-flex  px-3 pb-3">
            <button
              className="btn button-1 w-auto ms-auto"
              onClick={() => OrderSuccesReject(showModal?.title)}
            >
              Submit
            </button>
          </div>
        </Modal>
      )}

      {showPurchaseModal?.open && (
        <Modal
          show={showPurchaseModal?.open}
          onHide={onClose}
          className="commonModal"
        >
          <Modal.Header className="border-bottom-0 bb-0 pb-0" closeButton>
            <Modal.Title className="h5">
              Remarks<span className="text-danger">*</span>
            </Modal.Title>
          </Modal.Header>
          <div className="p-3">
            <FormControl
              value={showPurchaseModal.remark}
              onChange={(e) => {
                setShowPurchaseModal({
                  ...showPurchaseModal,
                  remark: e?.target?.value,
                });
              }}
              placeholder="Enter remarks"
              as="textarea"
            />
            {errorReason !== "" && (
              <small className="text-danger">{errorReason}</small>
            )}
          </div>
          <div className="d-flex  px-3 pb-3">
            <button
              className="btn btn-dark button-1 w-auto ms-auto"
              onClick={() => PromoEligibilityAccepted()}
            >
              Submit
            </button>
          </div>
        </Modal>
      )}
    </tbody>
  );
};

export default TableBody;
